// extracted by mini-css-extract-plugin
export var legendIndicator = "_cw-1";
export var legendRight = "_cw-0";